export const PKG_NAME = '@axa-asia/emma-iam-error';

export type Store = {
  [PKG_NAME]: ScopedStore;
};

export type ScopedStore = {
  errorConfig?: IamErrorConfig;
};

export const initialStore: ScopedStore = {
  errorConfig: undefined,
};

export const FEATURE_CODE_MAP = {
  registration: 'CUS',
  forgetUsername: 'RES',
  findMyPolicy: 'FMP',
  login: 'LGI',
} as const;

export const SHORT_POLICY_CODE = {
  eb: 'EB',
  pnc: 'PC',
  life: 'LF',
} as const;

export type FeatureName =
  | 'registration'
  | 'forgetUsername'
  | 'findMyPolicy'
  | 'login';

export type IamErrorConfig = {
  pageTitle: string;
  apiErrorCode: string;
  contacts: string[];
  featureName: FeatureName;
  featureCode: (typeof FEATURE_CODE_MAP)[keyof typeof FEATURE_CODE_MAP];
  policyCode: (typeof SHORT_POLICY_CODE)[keyof typeof SHORT_POLICY_CODE];
  fromPage: string;
};
